/** @format */

import React, { useState, useEffect, useContext } from "react";
import { useHistory, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import DeleteModal from "./DeleteModal";
import FileModal from "./FileModal";
import SpinnerLoading from "../Common/SpinnerLoading";
import Select from "react-select";
import { AIAsisstentServices } from "../../Services/ai-assistant.services";
import ListAdminButtons from "../Common/ListAdminButtons";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import Tooltip from "../Common/Tooltip";
import { aiConfig } from "../../Config/Consts";

import { useForm, Controller } from "react-hook-form";
import { AI_CHAT_CONFIG_ADMIN } from "../../Config/AIChatConfig";
import { fil, ro } from "date-fns/locale";

const STATUS_CODES = [
  {
    id: 0,
    title: "In progress",
    color: "grey",
  },
  {
    id: 1,
    title: "Finished",
    color: "green",
  },
  {
    id: 2,
    title: "Error",
    color: "red",
  },
];

const Index = () => {
  const history = useHistory();
  const { userId, roleId } = useContext(AuthContext);
  const { master, admin, support } = roles;
  const [document, setDocument] = useState(null);
  const { t: translator } = useTranslation();
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    updateLocKey,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);

  const { control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [data, setData] = useState([]);
  const [update, setUpdate] = useState(new Date());
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [filters, setFilters] = useState({
    searchText: "",
    statusId: null,
    configId: AI_CHAT_CONFIG_ADMIN.tenantId,
  });

  React.useEffect(() => {
    updateLocName("knowledge-base");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
    updateLocKey(0);
  }, []);

  useEffect(() => {
    AIAsisstentServices.getFiles({
      page: pagination.pageIndex,
      pageSize: pagination.pageSize,
      filterValues: filters,
      configId: filters.configId,
    })
      .then((res) => {
        setData(res.data.results);
        setPagination({ ...pagination, totalCount: res.data.total });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, [update, filters]);

  const handleToAdd = () => {
    setShowFileModal(true);
  };

  const handleRefresh = () => {
    setIsLoading(true);
    setPagination({ ...pagination, pageIndex: 0 });
    setUpdate(new Date());
  };

  const handleInputChange = (event) => {
    setIsLoading(true);
    const { name, value } = event.target;
    setFilters({ ...filters, [name]: value });
    setPagination({ ...pagination, pageIndex: 0 });
  };

  const handleHideDeleteModal = () => setShowDeleteModal(false);
  const handleHideFileModal = () => setShowFileModal(false);

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach((x) => {
      deletePromises.push(AIAsisstentServices.deleteFiles(x, filters.configId));
    });

    Promise.all(deletePromises).then((data) => {
      setUpdate(new Date());
      setShowDeleteModal(false);
      setSelectedItems([]);
    });
  };

  const handleAddFile = async () => {
    //setLoading(true);
	console.log("document",document);

	

    try {
      await AIAsisstentServices.postFiles(document, filters.configId);
    } catch (error) {
      console.log("error", error);
    } finally {
      //setLoading(false);
      setShowFileModal(false);
      setUpdate(new Date());
    }
  };
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      try {
        window.location.href = row.downloadUrl;
      } catch (error) {
        console.log("error", error);
      }
    },
  };
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.id]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.id));
    }
  };

  const handleOnSelectAll = (isSelect) => {
    if (isSelect) {
      setSelectedItems(data.map((x) => x.id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setIsLoading(true);
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="id"
        data={data}
        columns={columns}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
        rowEvents={rowEvents}
      />
    </div>
  );

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={selectedItems.find((x) => x === row.id)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }
  function statusFormatter(cell, row) {
    return (
      <span
        className="badge badge-pill"
        style={{
          backgroundColor: STATUS_CODES[row.statusId]?.color,
          fontSize: 15,
          color: "#fff !important",
        }}
      >
        {translator(cell)}
      </span>
    );
  }

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            name="workingMode"
            checked={
              data &&
              data.length > 0 &&
              !data.map((p) => p.id).some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
    },
    {
      dataField: "name",
      text: translator("KnowlageBase-List-TableHeader-Name"),
      //headerEvents: { onClick: () => sorting('InventoryNumber') },
    },
    {
      text: translator("KnowlageBase-List-TableHeader-Status"),
      dataField: "statusName",
      formatter: statusFormatter,
    },
  ];

  return (
    <div className="p-2">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("KnowlageBase-List-Overview")} </span>
          <span className="badge badge-pill badge-primary">
            {" "}
            {!isLoading ? pagination.totalCount : null}
          </span>
          {[master, admin, support].includes(Number(roleId)) && (
            <button
              className={
                "btn btn-primary float-right" + (isMobile ? " btn-sm" : "")
              }
              onClick={handleToAdd}
            >
              <span
                className="icon icon-cancel web-hidden"
                style={{ transform: "rotate(45deg)" }}
              ></span>{" "}
              <span className="mob-hidden">
                {translator("KnowlageBase-List-AddDocument")}
              </span>
            </button>
          )}
        </div>
        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("POS-List-labelFilters")}
            </legend>
            <form
              className="row"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group col-lg-3">
                <label>{translator("POS-List-labelTag")}</label>{" "}
                <Tooltip text={translator("POSTooltip-Msg")} />
                <input
                  name="searchText"
                  type="text"
                  className="form-control"
                  defaultValue={filters.searchText}
                  onChange={handleInputChange}
                />
              </div>
              <div className="form-group col-lg-3">
                <label htmlFor="ddlStore">{translator("Baza znanja")}</label>

                <select
                  className="form-control"
                  name="configId"
                  control={control}
                  placeholder={translator("Select-Knowledge-Base")}
                  onChange={(event) => {
                    console.log(event.target.value);
                    setIsLoading(true);

                    setFilters({ ...filters, configId: event.target.value });
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                >
                  {aiConfig.map((s) => (
                    <option value={s.id}>{s.name}</option>
                  ))}
                </select>
              </div>
            </form>
          </fieldset>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <ListAdminButtons
              selectedItemsLength={selectedItems.length}
              handleDelete={
                [admin, support, master].includes(Number(roleId))
                  ? () => setShowDeleteModal(true)
                  : null
              }
              handleRefresh={handleRefresh}
            />
          </div>
          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={data}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              noDataIndication={translator("No-Data")}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>

      <DeleteModal
        show={showDeleteModal}
        handleHide={handleHideDeleteModal}
        title={translator("Knowlwdge-Base-DeleteModal-Title")}
        text={translator("Knowlwdge-Base-DeleteModal-Text")}
        confirmDelete={confirmDelete}
      />
      <FileModal
        show={showFileModal}
        handleHide={handleHideFileModal}
        title={translator("Knowlwdge-Base-DeleteModal-Title")}
        text={translator("Knowlwdge-Base-DeleteModal-Text")}
        handleAddFile={handleAddFile}
        setDocument={setDocument}
      />
    </div>
  );
};
export default Index;
